import { render, staticRenderFns } from "./ConfirmPassword.vue?vue&type=template&id=84970c6a&scoped=true"
import script from "./ConfirmPassword.vue?vue&type=script&lang=js"
export * from "./ConfirmPassword.vue?vue&type=script&lang=js"
import style0 from "./ConfirmPassword.vue?vue&type=style&index=0&id=84970c6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84970c6a",
  null
  
)

export default component.exports